"use client";

import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { KaemmereiGenerator } from "@/components/cockpit/KaemmereiGenerator";

export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage/vorlagen/kaemmerei")({
  head: () => ({
    meta: [
      { title: "Vorlage für die Kämmerei – 100 Tage im Amt – Cockpit – creategy" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: KaemmereiRoute,
});

/** Ticket Z9: Eigene Unterseite für die Vorlage an die Kämmerei. */
function KaemmereiRoute() {
  return (
    <div className="space-y-8">
      <div>
        <Link
          to="/cockpit/hundert-tage"
          className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          Zurück zur Übersicht
        </Link>
        <div className="mt-3">
          <CockpitPageHeader
            title="Vorlage für die Kämmerei"
            description="Die gewünschten Leistungen mit Vergütung als vorbereitetes Dokument – zum Einreichen in der Kämmerei, jeweils als PDF."
          />
        </div>
      </div>

      <KaemmereiGenerator />
    </div>
  );
}
